import { CheckNotes, InspectionCase } from '../inspection-cases';

export class Standard_1205_Dto extends InspectionCase {
  systemInstallationAccordingSpec?: InspectionCase;
  waterSupplyPipesInstallationAccordingSpec?: InspectionCase;
}

export class Standard_1205 extends Standard_1205_Dto {
  constructor(data: Standard_1205_Dto = { title: 'תקן 1205' }) {
    super(data);
    this.systemInstallationAccordingSpec = new InspectionCase({
      ...data.systemInstallationAccordingSpec,
      title: 'המערכת מותקנת בהתאם לתכניות הביצוע',
      section: '2.1'
    });
    this.waterSupplyPipesInstallationAccordingSpec = new InspectionCase({
      ...data.waterSupplyPipesInstallationAccordingSpec,
      title:
        'צנרת אספקת המים לא הותקנה ברכיבי השלד, ברצפת קומת הקרקע או ברצפת המרתף',
      section: '3.3.1'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.systemInstallationAccordingSpec.isApplicable ||
        this.systemInstallationAccordingSpec.isPassed) &&
        (!this.waterSupplyPipesInstallationAccordingSpec.isApplicable ||
          this.waterSupplyPipesInstallationAccordingSpec.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.systemInstallationAccordingSpec.getNotes(),
      ...this.waterSupplyPipesInstallationAccordingSpec.getNotes()
    ];
  }
}
